import React, { useState, useEffect } from "react";

// MaterialUI
import { Tooltip } from "@mui/material";

// FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

// Components
import Modal from "components/Common/Modal/Modal";
import LoadingSpinner from "components/Common/LoadingSpinner/LoadingSpinner";

// Utils
import { getCommentHistory } from "utils/bqmq.utils";
import { toDateAndTimeSeconds } from "utils/general.utils";

// Styles
import CommentHistoryModalContainer from "./CommentHistoryModal.styles";

type Props = {
    commentId: string;
    setShowModal: (show: boolean) => void;
};

export default function CommentHistoryModal({
    commentId,
    setShowModal,
}: Props) {
    const [commentHistory, setCommentHistory] = useState<SessionComment[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (commentId) {
            fetchCommentHistory();
        }
    }, [commentId]);

    const fetchCommentHistory = async () => {
        setLoading(true);
        try {
            const history = await getCommentHistory(commentId);
            setCommentHistory(history);
        } catch (error) {
            console.error("Failed to fetch comment history:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setShowModal(false);
        setCommentHistory([]);
    };

    return (
        <Modal onClose={handleClose} width="600px">
            <CommentHistoryModalContainer>
                <div className="modal-header">
                    <h2>Comment History</h2>
                    <Tooltip title="Close">
                        <FontAwesomeIcon
                            icon={faTimes}
                            onClick={handleClose}
                            className="close-button"
                        />
                    </Tooltip>
                </div>
                <div className="modal-content">
                    {loading && <LoadingSpinner></LoadingSpinner>}
                    {commentHistory.map((comment) => (
                        <div key={comment.id} className="history-item">
                            <div className="comment-header">
                                <span className="comment-date">
                                    {toDateAndTimeSeconds(comment.created)}
                                </span>
                            </div>
                            <div className="comment-text">
                                {comment.comment_text}
                            </div>
                        </div>
                    ))}
                </div>
            </CommentHistoryModalContainer>
        </Modal>
    );
}
